<template>
    <div style='background-color:"#16a085"'>
        <div class="container">
            <div class="d-flex d-flex justify-content-between">
            <div class="input-group col-8 px-0 py-2">
                <!-- a class="btn btn-secondary my-1" @click="window.history.back();">Zurück</a-->
                <div class="input-group-prepend">
                    <b-btn
                        class="btn btn-outline-secondary my-1"
                        variant="btn-outline-secondary"
                        @click="window.history.back();"
                    >Zurück</b-btn>
                </div>
                <div class="input-group-append">
                    <b-btn
                        class="btn btn-outline-secondary my-1"
                        variant="btn-outline-primary"
                        @click="window.location = '/logoutandredirecttostockscan'"
                    >{{(user) ? user.name : ''}} ausloggen</b-btn>
                </div>
            </div>
                <h5 class="my-0 pt-2 mt-1">Erfassung Ausschussware</h5>
                <!--4011846009498 <span v-if="materialId != null">{{materialIds}}</span>-->
                <!-- noch nie verkauft: 9783403153184 -->
                <!-- gesperrt: 5099950849628 -->
            </div>
            <div class="input-group input-group-lg pb-1">
                <input type="text"
                    style="text-align: right;"
                    :class="{'form-control': true, 'bg-success': (state == 'no_match'), 'bg-info': (state == 'match'), 'bg-danger': ((this.state == 'blocked') || (this.storability.hasCustomerOrderItem == false))}"
                    placeholder="EAN"
                    required
                    v-model="scannedEan"
                    ref="refEan"
                    onClick="this.select()"
                    @keypress.enter="goToCustomItemNoteTemplate()"
                >
            </div>


            <div id="customItemNoteTemplate" class="input-group input-group-lg pb-1">
                <b-form-select
                    :disabled="!scannedEan"
                    :class="{ 'float-right': true, 'bg-info': templateNotSelected }" 
                    ref="customItemNoteTemplate"
                    v-model="customItemNoteTemplateId"
                    :options="customItemNoteTemplateOptions"
                ></b-form-select>
            </div>

            <div class="input-group input-group-lg pb-1">
                <input
                    id="qty"
                    type="text"
                    style="text-align: right;"
                    class="form-control"
                    :disabled="storability.state === 3 || state == null"
                    placeholder="Menge"
                    v-model="quantity"
                    @click="quantityClicked"
                >
            </div>

            <div class="input-group input-group-lg pb-1">
                <input
                    type="text"
                    style="text-align: right;"
                    :class="{ 'form-control': true , 'error-border': validateStockyard }"
                    :disabled="storability.state === 3 || null == state"
                    placeholder="Lagerplatz"
                    required
                    v-model="stockyard"
                    onClick="this.select()"
                    @keypress.enter="save()"
                >
            </div>
            <div class="py-2">
                <!-- Ean-feld ist unberührt-->
                <b-button
                    class="input-group-append btn btn-lg btn-block  mb-1 float-right"
                    style="padding-top: 5px; height: 85px;"
                    :variant="buttonVariant"
                    :disabled="disableButton"
                    @click="save()"
                >
                    <b-col class="m-3 p-3">
                        <b-row>
                            <span v-if="storability.state === null" class="icon icon-minus mx-auto"></span>
                            <span v-else-if="storability.state === 0" class="mx-auto">
                                <span  class="spinner-border spinner-border-sm mx-auto" role="status" aria-hidden="true"></span>
                                <span class="sr-only">Loading...</span>
                            </span>
                            <span v-else-if="storability.state === 1 || storability.state ===  2" class="mx-auto"><b-icon icon="check-lg"></b-icon></span>      
                            <span v-else-if="storability.state === 3" class="mx-auto">Ist geblockt</span>       
                            <span v-else class="mx-auto">-</span>         
                        </b-row>
                        <b-row/>
                    </b-col>
                </b-button>
            </div>
            <!-- Reset Button -->
            <div class="py-2">
                <button
                    type="button"
                    class="input-group-append btn btn-lg btn-secondary btn-block  mb-1 float-right"
                    :disabled="!scannedEan"
                    style="padding-top: 5px; height: 65px;"
                    @click="wipe()"
                >
                    <b-col class="mx-3 my-1 p-3">
                        <b-row>
                            <span class="icon icon-bin mx-auto"></span>
                        </b-row>
                        <b-row/>
                    </b-col>

                </button>
            </div>

        </div>

    </div>
</template>
<style scoped>
.error-border {
   border: 4px solid red!important;
   background-color: #FFCCCC!important;
}
</style>
<script>
    export default {
        data() {
            return {
                user: null,
                markets: [],
                state: null,
                scannedEan: '',
                materialId: null,
                quantity: null,
                stockyard: null,
                comment: null,
                df: null,
                customItemNoteTemplateId: null,
                customItemNoteTemplates: null,
                templateNotSelected: true,
                warehouseVendorId: 28,

                storability: {
                    materialId: null,
                    additional: false,
                    hasCustomerOrderItem: "unknown",
                    state: null 
                    //state: 0 query in progress
                    //state: 1 found & not blocked 
                    //state: 2 not found 
                    //state: 3 blocked
                }
            }
        },
        methods: {
            quantityClicked()
            {
                if(this.quantity == null || this.quantity ==  '')
                {
                    this.quantity = 1
                };

                //this.$refs["quantity"][0].select();
                Vue.nextTick(
                    () => {
                        //this.$refs.refQuantity.select();
                    }
                );
            },

            goToCustomItemNoteTemplate()
            {
                this.$refs.customItemNoteTemplate.focus();
            },

            isMaterialStorable() { // i.e. "darf der Artikel eingelagert werden"
                return new Promise( (resolve, reject) => {
                    this.storability = {
                        materialId: null,
                        productId: null,
                        additional: false,
                        state: 0
                    };
                    axios.get('/material/temporarily_storable/' + this.scannedEan + '/null/warehouse/' + this.warehouseVendorId)
                    .then( materialResponse => {
                        this.storability = materialResponse.data;
                        this.stockyard = null;
                        this.quantity = null;
                        let request = {
                            scannedEan: this.scannedEan,
                            customItemNoteTemplateId: this.customItemNoteTemplateId
                        };

                        axios.post('/temporarydamagedgoods/get', request )
                        .catch( error => { console.error(error); alert("Ein Fehler bei der ."); return; })
                        .then( response => {
                            let tempArticle = response.data[0];
                            if(tempArticle === undefined || tempArticle == null)
                            {
                                this.stockyard = '';
                                this.state     = 'no_match';
                            }
                            else
                            {
                                this.customItemNoteTemplateId = tempArticle.customItemNoteTemplateId;
                                this.stockyard         = tempArticle.stockyard;
                                this.quantity         = tempArticle.quantity;
                                this.state          = 'match';
                            };
                            this.storability.state = 1;                        

                            axios.get('/mds/blocker_computed/' + this.storability.productId)
                            .then( blockerComputedResponse => {
                                //check if all blockerComputeds exist and are all Blacklist entries... //8010939301163
                                let isBlocked = this.markets.reduce((otherMarkets, market) => {
                                    let blockerComputed = blockerComputedResponse.data.find( b => b.marketId === market.id )
                                    if(!blockerComputed) return false;
                                    return otherMarkets && blockerComputed.blackOrWhite;
                                }, true);

                                if(isBlocked)
                                {
                                    console.log('blocked');
                                    this.storability.state = 3;
                                    this.state = "blocked"
                                }
                                else if(this.storability.productId == null)
                                {
                                    console.log('no_match');
                                    this.storability.state = 2;
                                    this.state = "no_match"
                                }
                                else
                                {
                                    console.log('match');
                                    this.storability.state = 1;
                                    this.state="match"
                                }                            
                                setTimeout( resolve(), 100 );
                            })
                        })
                    }).catch( error => {
                        alert("Netzwerkfehler! Achtung: Es kann nicht überprüft werden, ob Artikel gesperrt ist!");
                        console.log(error);
                        reject(error);
                    });
                });
            },
            wipe() {
                //wipe all fields, start anew
                this.state = null;
                this.customItemNoteTemplateId = null;
                this.templateNotSelected = true,
                this.quantity = null;
                this.stockyard = null;
                this.comment = null;
                this.scannedEan = null;
                this.materialId = null;
                this.$refs.refEan.focus(); //sets focus
                this.storability = {
                    materialId: null,
                    additional: false,
                    state: null
                }
            },
            save()
            {
                if( this.storability.state !==  1 && this.storability.state !== 2 ) {
                    return;
                }

                let req = {
                    id:                       null,
                    ean:                      this.scannedEan,
                    customItemNoteTemplateId: this.customItemNoteTemplateId,
                    quantity:                 this.quantity,
                    stockyard:                this.stockyard,
                    user:                     this.user.name,
                };

                if(!this.scannedEan               ) { alert('EAN muss angegeben werden.'        ); return }
                if(!this.customItemNoteTemplateId ) { alert('Zustand muss angegeben werden.'    ); return }
                if(!this.quantity                 ) { alert('Menge muss angegeben werden.'      ); return }
                if(!this.stockyard                ) { alert('Lagerplatz muss angegeben werden.' ); return }
                if(!this.user                     ) { alert('user fehlt.'                       ); return }

                axios.post('/temporarydamagedgoods/save', req)
                .then( this.wipe )
                .catch( error => {
                    console.error(error);
                    this.storability = {
                        materialId: null,
                        additional: false,
                        state: null
                    }
                    alert("Änderungen wurden aufgrund eines Fehlers verworfen.");
                });
            },
            getWarehouseListItemDebounced: function () {
                console.log('getWarehouseListItemDebounced');
                if (this.scannedEan
                && (this.scannedEan.toString().length > 1)
                && (this.customItemNoteTemplateId != null)
                ){
                    this.df.call();
                }
            }
        },
        computed: {
            customItemNoteTemplateOptions: function() {
                console.log('customItemNoteTemplateOptions');
                if(!this.customItemNoteTemplates)
                return [ { value: -1, text: 'Daten werden geladen...' } ];
                else return this.customItemNoteTemplates.map( t => { return { value: t.id, text: t.name } });
            },
            validateStockyard: function() { return !/^[a-z,A-Z,ö,ü,ä,Ö,Ä,Ü,ß].{0,7}$/.test(this.stockyard) },
            buttonVariant(){
                switch(this.storability.state){
                    case null: return 'secondary';
                    case 0: return 'warning';
                    case 1: return 'primary';
                    case 2: return 'primary';
                    case 3: return 'danger'; 
                    default: return 'secondary';

                }
            },
            disableButton(){
                switch(this.storability.state){
                    case null: return true;
                    case 0: return true;
                    case 1: return false;
                    case 2: return false;
                    case 3: return true;
                    default: return true;
                }                
            }

        },
        watch: {
            customItemNoteTemplateId: function(cnew, cold) {
                this.templateNotSelected = false;
                this.getWarehouseListItemDebounced();
            }
        },
        created()
        {
            Promise.all([
               axios.get('user/authorization')
             , axios.get('customitemnote/template/all')
             , axios.get('user/self')
             , axios.get('/mds/market')
            ]).then( ([AuthResponse, CustomItemNoteTemplateResponse, userResponse, marketResponse]) => {

                this.user = userResponse.data;
                this.customItemNoteTemplates = CustomItemNoteTemplateResponse.data;
                this.customItemNoteTemplateId = this.customItemNoteTemplates[0].id;
                this.markets = marketResponse.data;

                let authorization = AuthResponse.data;
            }).catch( error => {
                console.log(error);
            });

            this.df = _.debounce( () => {
                this.isMaterialStorable()   
            }, 250, { maxWait:650 });

        },
        mounted()
        {
            this.$refs.refEan.focus();
        }
    }

</script>
